<template>
  <div :style="divStyle">
    <table v-if="emailApp === 'outlook'" border="0" style="display: inline">
      <tr>
        <td :style="outlookCellStyle">
          <img :src="url" :width="width" :height="height" :alt="alt" :style="outlookImageStyle">
        </td>
      </tr>
    </table>

    <div v-if="emailApp === 'gmail'" :style="gmailStyle"></div>
  </div>
</template>

<script>
export default {
  name: "EmailSafeImage",
  props: {
    'url': String,
    'width': Number,
    'height': Number,
    'alt': String,
    'emailApp': String,
    'paddingRight': Number,
    'paddingLeft': Number,
    'float': String
  },
  computed: {
    divStyle() {
      return {
        textAlign: (this.float === 'right') ? 'right' : null
      }
    },
    outlookCellStyle() {
      return {
        paddingLeft: `${this.paddingLeft}px`,
        paddingRight: `${this.paddingRight}px`
      }
    },
    outlookImageStyle() {
      return {
        verticalAlign: 'middle'
      }
    },
    gmailStyle() {
      return {
        width: `${this.width + this.paddingRight + this.paddingLeft}px`,
        height: `${this.height}px`,
        background: `url(${this.url}) ${this.paddingLeft}px 0/${this.width}px ${this.height}px no-repeat`,
        float: (this.float) ? this.float : 'none'
      }
    }
  }
}
</script>

<style scoped>

</style>
